// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — ZonesMap.classic.js, новая — ZonesMap.cp.js
import { isCp } from 'libs/design';
import * as classic from './ZonesMap.classic';
import * as cp from './ZonesMap.cp';

export const ZonesMap = isCp ? cp.ZonesMap : classic.ZonesMap;
